<script setup lang="ts" name="OrganisationPortCallsDetailsCargoFilters">
import { useVModel } from '@vueuse/core';

import { useActiveFilters } from '~/features/useActiveFilters';

import type {
  IFilter,
  IOption,
  IPortCallsCargoQuery,
  IPortCallsCargoTypeQuery,
} from '~/types';

import FilterMenuSelectMultiple from './FilterMenuSelectMultiple.vue';
import FiltersLayout from './FiltersLayout.vue';
import FilterTag from './FilterTag.vue';

const props = defineProps<{
  modelValue: IPortCallsCargoQuery;
  ports: IOption[];
  types: IPortCallsCargoTypeQuery[];
}>();

const emit = defineEmits<{
  'update:modelValue': [];
  clearFilters: [];
  clearFilter: [filter: IFilter];
}>();

const query = useVModel(props, 'modelValue', emit);

const { activeFilters, clearFilter, clearQuery } = useActiveFilters(query);

const clearActiveFilter = (filter: IFilter) => {
  const newQuery = clearFilter(filter, query);
  query.value.ports = newQuery.ports;
  query.value.types = newQuery.types;
};

const clearAllFilters = () => {
  const newQuery = clearQuery(query);
  query.value.ports = newQuery.ports;
  query.value.types = newQuery.types;
};
</script>
<template>
  <FiltersLayout @clear="clearAllFilters">
    <FilterMenuSelectMultiple
      v-model="query.ports"
      label="Destination"
      :options="ports"
    />
    <FilterMenuSelectMultiple
      v-model="query.types"
      label="Type"
      :options="types"
    />
    <template v-if="activeFilters.length" #tags>
      <FilterTag
        v-for="filter in activeFilters"
        :key="filter.id"
        :name="filter.label"
        @click="clearActiveFilter(filter)"
      />
    </template>
  </FiltersLayout>
</template>
